import { Component } from "solid-js";

interface CancellationSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CancellationSuccessModal: Component<
  CancellationSuccessModalProps
> = (props) => {
  return (
    <fd-mfe-modal-dialog
      prop:open={props.isOpen}
      data-testid="cancellation-success-modal"
    >
      <h2 slot="modal-dialog-header" data-testid="cancellation-success-heading">
        Cancellation successful
      </h2>
      <p slot="modal-dialog-body" data-testid="cancellation-success-message">
        Your Featured Dealer reservation has been successfully canceled. You
        will not be billed for this service.
      </p>
      <fd-mfe-modal-dialog-footer slot="modal-dialog-footer">
        <fd-mfe-button onClick={props.onClose}>Back to marketing</fd-mfe-button>
      </fd-mfe-modal-dialog-footer>
    </fd-mfe-modal-dialog>
  );
};
